import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
  ImportCsvExcelTradesRequestModel,
  ImportCsvExcelTradesResponseModel,
  ImportMergeCsvExcelTradesRequestModel,
  ImportMergeCsvExcelTradesResponseModel,
} from "@/features/accounts/csv-excel/services/import_trades_model";

export class ImportCsvExcelTradesApi {
  /**
   * CsvExcel明細アップロードAPI
   */
  public ImportCsvExcelTrades = async (
    param: ImportCsvExcelTradesRequestModel
  ): Promise<ImportCsvExcelTradesResponseModel> => {
    const path = `/api/csvexcelaccounts/trades/import`;

    // FormDataとして送信
    const formData = new FormData();
    formData.append("account_group_id", param.account_group_id);
    formData.append("csvexcel_account_id", param.csvexcel_account_id);
    formData.append("file", param.file);
    formData.append("file_type", param.file_type);
    if (param.bank_code) formData.append("bank_code", param.bank_code);
    if (param.passbook_name) formData.append("passbook_name", param.passbook_name);

    const res = await ApiClient.instance.postBytes<ImportCsvExcelTradesResponseModel>({
      path: path,
      params: formData as NonNullable<unknown>,
    });

    if (res.ok === false) {
      res.body.status = "error"
      res.body.error_message = res.errorMessage || "不明なエラーが発生しました";
      return res.body;
    }

    return res.body;
  };

  /**
   * CsvExcel明細アップロードAPI(重複期間対応時)
   */
  public ImportMergeCsvExcelTradesMerge = async (
    param: ImportMergeCsvExcelTradesRequestModel
  ): Promise<ImportMergeCsvExcelTradesResponseModel> => {
    const path = `/api/csvexcelaccounts/trades/import/merge`;

    // FormDataとして送信
    const formData = new FormData();
    formData.append("account_group_id", param.account_group_id);
    formData.append("csvexcel_account_id", param.csvexcel_account_id);
    formData.append("file", param.file);
    formData.append("file_type", param.file_type);
    if (param.bank_code) formData.append("bank_code", param.bank_code);
    if (param.passbook_name) formData.append("passbook_name", param.passbook_name);
    if (param.balance_continue_state) formData.append("balance_continue_state", param.balance_continue_state.toString());
    if (param.exclusion_condition) formData.append("exclusion_condition", param.exclusion_condition.toString());

    const res = await ApiClient.instance.postBytes<ImportMergeCsvExcelTradesResponseModel>({
      path: path,
      params: formData as NonNullable<unknown>,
    });

    if (res.ok === false) {
      res.body.status = "error"
      res.body.error_message = res.errorMessage || "不明なエラーが発生しました";
      return res.body;
    }

    return res.body;
  };
}
